module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-BoldItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-BoldItalic.woff
 ** module id = 1104
 ** module chunks = 0
 **/